import React, { useEffect, useMemo, useState } from "react";
import axiosInstance from "../helpers/axios";
import Wrapper from "../components/wrapper";
import ServerSideTable from "../components/table/serverSideTable";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Layout,
  Form,
  Input,
  Badge,
  Button,
  Tag,
  Tooltip,
  notification,
  Popconfirm,
} from "antd";
import {
  fetchToDeactivateMenus,
  approvalMenuStatus,
} from "../redux/actions/validateMenuStatus";

const { Content: LayoutContent } = Layout;
const { Search } = Input;
const ValidateMenuStatus = () => {
  const dispatch = useDispatch();
  const {
    loading,
    data,
    totalRecord,
    nextPage,
    previousPage,
    currentPage,
    userInfo,
  } = useSelector(({ validateMenuStatusReducer, userLoginReducer }) => ({
    data: validateMenuStatusReducer.data,
    totalRecord: validateMenuStatusReducer.totalRecord,
    nextPage: validateMenuStatusReducer.nextPage,
    previousPage: validateMenuStatusReducer.previousPage,
    currentPage: validateMenuStatusReducer.currentPage,
    loading: validateMenuStatusReducer.loading,
    userInfo: userLoginReducer.userInfo,
  }));
  const [searchText, setSearchText] = useState("");
  const [delaySearchText, setDelaySearchText] = useState("");
  const [isStatus, setIsStatus] = useState(null);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDelaySearchText(searchText);
    }, 300);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchText]);

  useEffect(() => {
    const payload = {
      page: 1,
      limit: 15,
      searchText: delaySearchText,
    };
    dispatch(fetchToDeactivateMenus(payload));
  }, [delaySearchText, dispatch]);

  const onSearch = () => {
    const payload = {
      page: 1,
      limit: 15,
      searchText,
    };

    dispatch(fetchToDeactivateMenus(payload));
  };

  const approved = async (item) => {
    try {
      const payload = {
        menuId: item.data.merchant_menu_id,
        status: item.status,
      };
      const { data } = await dispatch(approvalMenuStatus(payload));
      console.log("---------> ", data);
      if (data !== undefined) {
        notification.success({
          message:
            item.status === 1
              ? "Deactivation of the menu is approved"
              : "Deactivation of the menu is not approved",
        });
      }
    } catch (error) {
      console.log("ERROR ---> approved || ", error);
    }
  };

  const customFilters = () => {
    return (
      <div className="mb-2">
        <h1 className="text-2xl md:text-3xl">Validate Menu Status</h1>
        <div className="p-2 flex flex-col md:flex-row md:items-center justify-between bg-gray-100 gap-2">
          <Form
            layout="inline"
            className="w-full md:w-auto flex flex-col md:flex-row md:gap-4"
          >
            <Form.Item className="w-full md:w-auto">
              <Search
                placeholder="input search text"
                allowClear
                className="w-full md:w-30"
                value={searchText}
                size="medium"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                onSearch={onSearch}
              />
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  };

  const defaultPage = useMemo(() => {
    return {
      page: 1,
      limit: 15,
    };
  }, []);

  const onClickNextPage = () => {
    dispatch(
      fetchToDeactivateMenus({
        ...nextPage,
        searchText,
      })
    );
  };

  const onClickPreviousPage = () => {
    dispatch(
      fetchToDeactivateMenus({
        ...previousPage,
        searchText,
      })
    );
  };

  const onClickFirstPage = () => {
    dispatch(
      fetchToDeactivateMenus({
        ...defaultPage,
        searchText,
      })
    );
  };

  const onClickLastPage = () => {
    dispatch(
      fetchToDeactivateMenus({
        page: Math.ceil(totalRecord / 15),
        limit: 15,
        searchText,
      })
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "Actions",
        Cell: ({ row: { original } }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              gap: 5,
            }}
          >
            <Popconfirm
              title="Are you sure you want to approved the deactivation of the menu?"
              onConfirm={() => approved({ data: original, status: 1 })}
              okText="Yes"
              cancelText="No"
              placement="right"
            >
              <Button style={{ backgroundColor: "#1E90FF" }} size="medium">
                <div style={{ color: "white" }}>Approve</div>
              </Button>
            </Popconfirm>
            <Popconfirm
              title="Are you sure you want to disapproved the the deactivation of the menu?"
              onConfirm={() => approved({ data: original, status: 0 })}
              okText="Yes"
              cancelText="No"
              placement="right"
            >
              <Button style={{ backgroundColor: "tomato" }} size="medium">
                <div style={{ color: "white" }}>Dispprove</div>
              </Button>
            </Popconfirm>
          </div>
        ),
      },
      {
        Header: "Status",
        accessor: (row) =>
          row.is_approved === 0 ? (
            <>
              <Badge status="error" text="Disapproved" />
            </>
          ) : row.is_approved === null ? (
            <>
              <Badge status="error" text="To Review" />
            </>
          ) : (
            <>
              <Badge status="success" text="Approved" />
            </>
          ),
      },

      {
        Header: "Merchant City",
        accessor: "city",
      },
      {
        Header: "Merchant Province",
        accessor: "province",
      },
      {
        Header: "Menu title",
        accessor: "title",
      },
      {
        Header: "Rider",
        accessor: "user_name",
      },

      {
        Header: "Rider Contact Number",
        accessor: "rider_contact",
      },
      {
        Header: "Application date",
        accessor: (row) => {
          const utcTime = moment.utc(row.created_at).tz("Asia/Manila");
          return utcTime.format("MMM D, YYYY hh:mm A"); // Format the time as needed
        },
      },
    ],
    []
  );
  {
    console.log("totalRecord : >>> ", totalRecord);
  }
  const renderContent = () => {
    return (
      <LayoutContent>
        <ServerSideTable
          columns={columns}
          data={data} //
          loading={loading}
          serverSidePagination={{
            totalRecord,
            onClickNextPage,
            onClickPreviousPage,
            currentPage,
            nextPage,
            previousPage,
            onClickFirstPage,
            onClickLastPage,
          }}
          customFilters={customFilters}
        />
      </LayoutContent>
    );
  };
  return (
    <div>
      <Wrapper content={renderContent()} />
    </div>
  );
};

export default ValidateMenuStatus;
